module.exports = __webpack_public_path__ + "static/secondary_logo-fc5437b63fe7b936dc1c383eeab109a5.png";